import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.orderInformationGridItem = {
    printWidth: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    order: 3;
                `,
                css`
                    order: 3;
                `,
                css`
                    order: 2;
                `,
                css`
                    order: 2;
                `,
                css`
                    order: 2;
                `,
            ])}
    `,
    width: [12, 12, 6, 8, 8],
};
orderConfirmationPageContainerStyles.orderTotalGridItem = {
    printWidth: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    order: 2;
                `,
                css`
                    order: 2;
                `,
                css`
                    order: 3;
                `,
                css`
                    order: 3;
                `,
                css`
                    order: 3;
                `,
            ])}
    `,
    width: [12, 12, 6, 4, 4],
};
orderConfirmationPageContainerStyles.productListGridItem = {
    printWidth: 12,
    css: css`
        order: 4;
    `,
    width: [12, 12, 12, 8, 8],
};
